export default "__VITE_ASSET__CbmwsZHl__"